import React, { useEffect, useState } from 'react';
import CheckboxField from "../CheckboxField";
import InputField from "../InputField/InputField";
import TextareaField from "../TextareaField/TextareaField";
import { Link } from "react-router-dom";
import Axios from '../../lib/axios/axiosInstance';
import { ErrorMessage, Formik } from "formik";
import * as Yup from 'yup'
import { Flip, Slide, toast } from 'react-toastify';
import "./Reviews.styles.css";

const Reviews = ({productDetail}) => {

  const [productDetails, setProductDetails] = useState(null);

  useEffect(async () => {
    setProductDetails(productDetail);
  }, [productDetail])

  const enquiryFormData = {
    priceRatings: '',
    valueRatings: '',
    qualityRatings: '',
    nickName: '',
    summary: '',
    writeReview: ''
  }

  const submitFormHandler = async (values) =>{
    var data= {
      review:{
        rate_price: values.priceRatings,
        rate_value: values.valueRatings,
        rate_quality: values.qualityRatings,
        nickname: values.nickName,
        summary: values.summary,
        content: values.writeReview
      }
    };
    // SubmitProductReview
    // api/product/productreview/:matnum
    await Axios.post(`product/productreview/${productDetails.matm?.matnum}`,data)
    .then(function (response) {
        if (response.status===200) {
          setProductDetails(response.data.data[0])
          toast.success('Reviewed successfully.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
            transition: Slide,
          });
        }
        else {
          toast.error('Reviewed failed.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
            transition: Slide,
          });
        }
    })
    .catch(function (error) {
      toast.error('Reviewed failed.', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 4000,
        transition: Slide,
      });
    });
  }

  return (
    <div className="box-collateral box-reviews" id="customer-reviews">
      <div className="box-reviews1">
        <div className="form-add">

          <Formik
            initialValues={enquiryFormData}
            validationSchema={Yup.object().shape({
              priceRatings: Yup.string()
                .required(' Plaese add review For price '),
              valueRatings: Yup.string()
                .required(' Plaese add review For value '),
              qualityRatings: Yup.string()
                .required(' Plaese add review For quality '),
              nickName: Yup.string()
                .required('Nick name  is required'),
              // summary: Yup.string()
              //   .required('Please write summary'),
              // writeReview: Yup.string()
              //   .required('Please write review'),
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              // console.log("values", values);
              setSubmitting(false);
              submitFormHandler(values);
              resetForm();
            }}
          >
            {props => {
              const {
                values,
                touched,
                errors,
                handleChange,
                handleSubmit,
              } = props;
              return (
                <form id="review-form" method="" onSubmit={handleSubmit}>
                  <h3>Write Your Own Review</h3>
                  <fieldset>
                    <h4>
                      How do you rate this product? <em className="required">*</em>
                    </h4>
                    <span id="input-message-box"></span>
                    <table id="product-review-table" className="data-table">
                      <colgroup>
                        <col />
                        <col width="1" />
                        <col width="1" />
                        <col width="1" />
                        <col width="1" />
                        <col width="1" />
                      </colgroup>
                      <thead>
                        <tr className="first last">
                          <th>&nbsp;</th>
                          <th>
                            <span className="nobr">1 *</span>
                          </th>
                          <th>
                            <span className="nobr">2 *</span>
                          </th>
                          <th>
                            <span className="nobr">3 *</span>
                          </th>
                          <th>
                            <span className="nobr">4 *</span>
                          </th>
                          <th>
                            <span className="nobr">5 *</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="first odd">
                          <th>Price <span style={{ color: 'red' }}>*</span></th>
                          <td className="value">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="1"
                              id="Price_1"
                              Name="priceRatings"
                              checked={values.priceRatings === '11'}
                              onChange={handleChange}

                            />
                          </td>
                          <td className="value">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="2"
                              id="Price_2"
                              Name="priceRatings"
                              checked={values.priceRatings === '12'} onChange={handleChange}

                            />
                          </td>
                          <td className="value">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="3"
                              id="Price_3"
                              Name="priceRatings"
                              checked={values.priceRatings === '13'} onChange={handleChange}

                            />
                          </td>
                          <td className="value">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="4"
                              id="Price_4"
                              Name="priceRatings"
                              checked={values.priceRatings === '14'} onChange={handleChange}

                            />
                          </td>
                          <td className="value last">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="5"
                              id="Price_5"
                              Name="priceRatings"
                              checked={values.priceRatings === '15'} onChange={handleChange}

                            />
                          </td>
                        </tr>
                        <ErrorMessage name='priceRatings' component="div" style={{ color: 'red', marginBottom: '5px' }} />
                        <tr className="even">
                          <th>Value <span style={{ color: 'red' }}>*</span></th>
                          <td className="value">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="1"
                              id="Value_1"
                              Name="valueRatings"
                              checked={values.valueRatings === '21'} onChange={handleChange}

                            />
                          </td>
                          <td className="value">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="2"
                              id="Value_2"
                              Name="valueRatings"
                              checked={values.valueRatings === '22'} onChange={handleChange}

                            />
                          </td>
                          <td className="value">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="3"
                              id="Value_3"
                              Name="valueRatings"
                              checked={values.valueRatings === '23'} onChange={handleChange}

                            />
                          </td>
                          <td className="value">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="4"
                              id="Value_4"
                              Name="valueRatings"
                              checked={values.valueRatings === '24'} onChange={handleChange}

                            />
                          </td>
                          <td className="value last">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="5"
                              id="Value_5"
                              Name="valueRatings"
                              checked={values.valueRatings === '25'} onChange={handleChange}

                            />
                          </td>
                        </tr>
                        <ErrorMessage name='valueRatings' component="div" style={{ color: 'red', marginBottom: '5px' }} />
                        <tr className="last odd">
                          <th>Quality <span style={{ color: 'red' }}>*</span></th>
                          <td className="value">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="1"
                              id="Quality_1"
                              Name="qualityRatings"
                              checked={values.qualityRatings === '31'} onChange={handleChange}

                            />
                          </td>
                          <td className="value">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="2"
                              id="Quality_2"
                              Name="qualityRatings"
                              checked={values.qualityRatings === '32'} onChange={handleChange}

                            />
                          </td>
                          <td className="value">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="3"
                              id="Quality_3"
                              Name="qualityRatings"
                              checked={values.qualityRatings === '33'} onChange={handleChange}

                            />
                          </td>
                          <td className="value">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="4"
                              id="Quality_4"
                              Name="qualityRatings"
                              checked={values.qualityRatings === '34'} onChange={handleChange}

                            />
                          </td>
                          <td className="value last">
                            <CheckboxField
                              Type="radio"
                              className="radio"
                              Value="5"
                              id="Quality_5"
                              Name="qualityRatings"
                              checked={values.qualityRatings === '35'} onChange={handleChange}

                            />
                          </td>
                        </tr>

                        <ErrorMessage name='qualityRatings' component="div" style={{ color: 'red', marginBottom: '5px' }} />
                      </tbody>
                    </table>
                    <input
                      type="hidden"
                      value=""
                      className="validate-rating"
                      name="validate_rating"
                    />
                    <div className="review1">
                      <ul className="form-list">
                        <li>
                          <div className="input-box">
                            <InputField
                              Type="text"
                              Name="nickName"
                              Labels="Nickname"
                              value={values.nickName}
                              onChange={handleChange}
                              isInvalid={!!errors.nickName}
                              className={(errors.nickName && touched.nickName) && 'is-invalid'}
                            />
                          </div>
                        </li>
                        <li>
                          <div className="input-box">
                            <InputField Type="text" Name="summary" Labels="Summary"
                              value={values.summary}
                              onChange={handleChange}
                              isInvalid={!!errors.summary}
                              className={(errors.summary && touched.summary) && 'is-invalid'}

                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="review2">
                      <ul>
                        <li>
                          <div className="input-box">
                            <TextareaField
                              Rows="3"
                              Cols="5"
                              ID="review_field"
                              Name="writeReview"
                              Labels="Review"
                              value={values.writeReview}
                              onChange={handleChange}
                              isInvalid={!!errors.writeReview}
                              className={(errors.writeReview && touched.writeReview) && 'is-invalid'}
                            />
                          </div>
                        </li>
                      </ul>
                      <div className="buttons-set">
                        <button
                          className="button submit"
                          title="Submit Review"
                          type="submit"
                        >
                          <span>Submit Review</span>
                        </button>
                      </div>
                    </div>
                  </fieldset>
                </form>
              )
            }}
          </Formik>
        </div>
      </div>
      <div className="box-reviews2">
        <h3>Customer Reviews</h3>
        <div className="box visible">
          <ul>
            {productDetails && productDetails.reviews && productDetails.reviews.map((review,i)=>{
              return <li>
                <table className="ratings-table">
                  <colgroup>
                    <col width="1" />
                    <col />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>Value</th>
                      <td>
                        <div className="rating-box">
                          <div className="rating" style={{ width: "100%" }}></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>Quality</th>
                      <td>
                        <div className="rating-box">
                          <div className="rating" style={{ width: "100%" }}></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>Price</th>
                      <td>
                        <div className="rating-box">
                          <div className="rating" style={{ width: "100%" }}></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="review">
                  <h6>
                    <Link to={`/product-detail?uuid=${review.uuid}`}>{review.summary}</Link>
                  </h6>
                  <small>
                    Review by <span>{review.nickname} </span>on {review.createdat.split('T')[0]}
                  </small>
                  <div className="review-txt">
                    {review.content}
                  </div>
                </div>
              </li>
            })}
          </ul>
        </div>
        <div className="actions">
          <Link className="button view-all" id="revies-button" to="/product-detail">
            <span>
              <span>View all</span>
            </span>
          </Link>
        </div>
      </div>
      <div className="clear"></div>
    </div>
  );
};

export default Reviews;
